import { createAsyncThunk } from "@reduxjs/toolkit";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import { RootState } from "@/store/store";
import { updateSavingsOpportunityViewThunk } from "@/store/savings-opportunities/thunks/views-hierarchy/actions/updateSavingsOpportunityViewThunk";
import { savingsOpportunityCurrentViewConfigSelector } from "@/store/savings-opportunities/selectors/views-hierarchy/current-view/savingsOpportunityCurrentViewConfigSelector";
import { savingsOpportunitiesCurrentViewIdSelector } from "@/store/savings-opportunities/selectors/views-hierarchy/current-view/savingsOpportunitiesCurrentViewIdSelector";
import { getSavingsOpportunitiesThunk } from "@/store/savings-opportunities/thunks/data-getters/getSavingsOpportunitiesThunk";
import { FilterTreeNodeWithId } from "@/components/pages/common/filters-tree/utils/types/common";
import { removeIdsFromFilterTreeItems } from "@/components/pages/common/filters-tree/utils/helpers/ids-manipulations/removeIdsFromFilterTreeItems";
import { savingsOpportunityCurrentViewProtectedSelector } from "@/store/savings-opportunities/selectors/views-hierarchy/current-view/savingsOpportunityCurrentViewProtectedSelector";

export const updateSavingsOpportunityCurrentViewFiltersThunk = createAsyncThunk(
  "savingsOpportunities/updateSavingsOpportunityCurrentViewFilters",
  async (
    filterTree: FilterTreeNodeWithId | undefined,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;

    const currentViewId = savingsOpportunitiesCurrentViewIdSelector(state);
    const config = savingsOpportunityCurrentViewConfigSelector(state);
    const isProtected = savingsOpportunityCurrentViewProtectedSelector(state);

    if (isProtected) {
      return;
    }

    try {
      if (currentViewId) {
        await dispatch(
          updateSavingsOpportunityViewThunk({
            viewId: currentViewId,
            body: {
              config: {
                ...config,
                filters: filterTree
                  ? removeIdsFromFilterTreeItems(filterTree)
                  : undefined,
              },
            },
          }),
        );
      }

      dispatch(getSavingsOpportunitiesThunk(filterTree));
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
    }
  },
);
